import { Outlet, useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SectionNavSkeleton, SectionTabs } from "@/components/app/SectionNav";
import { useFeatures, visibilityOf, isNavVisible } from "@/lib/license";
import { useConnectors } from "@/lib/connectors";
import { visibleTestingSections } from "@/pages/testing/testingNav";

/**
 * Testovací nástroje — hlavička + horní underline lišta (mirror {@link SettingsLayout},
 * jen plochá: nástrojů je málo, takže se neseskupují a hub nemá rozcestník).
 * Položky jsou gatované feature × přítomností konektoru.
 */
export function TestingLayout() {
  const { t } = useTranslation();
  const features = useFeatures();
  const connectors = useConnectors();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const show = (id: string) => isNavVisible(visibilityOf(features.data, id));
  const hasConnector = (type: string) => (connectors.data ?? []).some((c) => c.connectorType === type);

  const sections = visibleTestingSections(show, hasConnector);
  const active = sections.find((s) => pathname === s.to || pathname.startsWith(s.to + "/"));

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-display-sm font-semibold text-primary">{t("testing.title")}</h1>
        <p className="mt-1 text-md text-tertiary">{t("testing.subtitle")}</p>
      </div>

      {features.isLoading ? (
        <SectionNavSkeleton />
      ) : (
        <SectionTabs
          aria-label={t("testing.title")}
          activeTo={active?.to ?? null}
          items={sections.map((s) => ({ to: s.to, label: t(s.labelKey) }))}
        />
      )}

      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
